﻿import { cn } from '@/lib/utils';
import { DatePicker } from '@/components/ui/date-picker';
import { TimePicker } from '@/components/ui/time-picker';

interface DateTimePickerProps {
  value: string | null;
  onChange: (value: string | null) => void;
  className?: string;
  disabled?: boolean;
  /** Days before this are not selectable. */
  minDate?: Date;
}

function splitValue(v: string | null): { date: string; time: string } {
  if (!v) return { date: '', time: '' };
  const [date = '', timePart = ''] = v.split('T');
  return { date, time: timePart.slice(0, 5) };
}

export function DateTimePicker({ value, onChange, className, disabled, minDate }: DateTimePickerProps) {
  const { date, time } = splitValue(value);

  const handleDate = (newDate: string) => {
    if (!newDate) { onChange(null); return; }
    onChange(`${newDate}T${time || '09:00'}`);
  };

  const handleTime = (newTime: string) => {
    if (!date) return;
    onChange(`${date}T${newTime || '09:00'}`);
  };

  return (
    <div className={cn('space-y-2', className)}>
      <DatePicker
        value={date}
        onChange={handleDate}
        placeholder="Pick a date"
        disabled={disabled}
        minDate={minDate}
        // Always used inside a Dialog. A modal popover there stacks a second pointer-events lock on
        // <body>; closing both together (Esc twice) left the page unclickable. Same fix as the
        // payroll/attendance dialogs, and matches the TimePicker below (non-modal by default).
        modal={false}
      />
      {/* TimePicker rather than <input type="time">: the native control renders in
          the OS colour scheme, which read as a light widget on the dark theme. */}
      <TimePicker
        value={time}
        onChange={handleTime}
        disabled={disabled || !date}
      />
    </div>
  );
}
